export default __webpack_public_path__ + "images/366a0a5b92a72b82119d2e983b54f780.svg";